import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { Edit } from '@mui/icons-material'

import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  TextareaAutosize,
} from '@mui/material'
import { useAppServices, useUploadImage } from 'hook/services'
import { useUserInfo } from 'context/user'
import FormField from 'components/FormField'
import MDInput from 'components/MDInput'
import { useParams } from 'react-router-dom'
import { useAgencyInfo } from 'context/agency'
import { Roles } from 'enums/user'
import Multiselect from '../../MultiSelect'

const CreateModal = ({ appData, handleRefresh }) => {
  const uploadImage = useUploadImage()
  const [agency] = useAgencyInfo()

  const { app_id } = useParams
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [tags, setTags] = useState([])
  const AppService = useAppServices()
  const [user] = useUserInfo()
  const [staffData, setStaffData] = useState([])
  const [ghlFeatures, setGhlFeatures] = useState([])
  const [team, setTeam] = useState([])
  const handlemodal = () => {
    setOpenAddProduct(true)
  }
  const getTags = async () => {
    const { response } = await AppService.team_tags.get({
      toaster: false,
    })
    if (response) {
      setTags(response.data)
    } else {
      setTags([])
    }
    // setLoader(false)
  }

  const getGhlFeatures = async () => {
    const { response } = await AppService.ghl_features.get({
      toaster: false,
    })
    if (response) {
      setGhlFeatures(response.data)
    } else {
      setGhlFeatures([])
    }
    // setLoader(false)
  }

  const getStaff = async () => {
    const { response } = await AppService.user.GetUsers()
    if (response) {
      setStaffData(response.data)
    } else {
      setStaffData([])
    }
    // setLoader(false)
  }
  const getTEam = async () => {
    const { response } = await AppService.team.get({})
    if (response) {
      setTeam(response.data)
    } else {
      setTeam([])
    }
    // setLoader(false)
  }
  const tagsOptions = tags?.map(item => ({
    label: item?.name,
    value: item?._id,
  }))
  const ghlfeaturesOptions = ghlFeatures?.map(item => ({
    label: item?.name,
    value: item?._id,
  }))
  const teamOptions = team?.map(item => ({
    label: item?.name,
    value: item?._id,
  }))
  const staffOptions = staffData?.map(item => ({
    label: item?.username,
    value: item?._id,
  }))
  useEffect(() => {
    getTags()
    getStaff()
    getTEam()
    getGhlFeatures()
  }, []);
  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)




    const handleSubmit = async (e) => {
      e.preventDefault()
      setProcessing(true)
      const payload = {
        name: e.target.name.value,
        description: e.target.description.value,
        points: e.target.points.value,
        staff_team: e.target.staff_team ? JSON.parse(e.target.staff_team.value) : [],
        team: e.target.team ? JSON.parse(e.target.team.value) : [],
        staff_tag: e.target.staff_tag ? JSON.parse(e.target.staff_tag.value) : [],
        ghl_features: e.target.ghl_features ? JSON.parse(e.target.ghl_features.value) : [],
      }

      const { response } = await AppService.staff_job.create({
        payload: payload,
      })
      // console.log(response)
      if (response) {
        setProcessing(false)
        onClose()
        handleRefresh()
      }
    }
    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      height: 'auto',
      overflow: 'auto',
      bgcolor: 'background.paper',
      border: '2px  #000',
      boxShadow: 24,
      p: 4,
    }
    return (
      <MDModal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Create Job
            </MDTypography>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Name
              </MDTypography>
              <MDInput label="Name" name="name" fullWidth />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Description
              </MDTypography>
              <TextareaAutosize
                minRows={3}
                name="description"
                style={{ width: '100%', padding: '8px', borderRadius: '4px', borderColor: '#ccc' }}
              />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Points
              </MDTypography>
              <MDInput label="Points" name="points" fullWidth />

            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Tags
              </MDTypography>
              <Multiselect data={tagsOptions} edit_data={[]} isMulti={true} name="staff_tag" />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Ghl Features
              </MDTypography>
              <Multiselect data={ghlfeaturesOptions} edit_data={[]} isMulti={true} name="ghl_features" />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Staff
              </MDTypography>
              <Multiselect data={staffOptions} edit_data={[]} isMulti={true} name="staff_team" />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Team
              </MDTypography>
              <Multiselect data={teamOptions} edit_data={[]} isMulti={true} name="team" />
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 4, mb: 1 }}
                onClick={closeAddProduct}
              >
                close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 4, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }
  const closeAddProduct = () => {
    // if (subscription?._id)
    setOpenAddProduct(false)
  }
  return (
    <>
      <MDButton color="white" size="small" variant="contained" onClick={handlemodal}>
        Create
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  )
}

export default CreateModal
